import { load } from "@shopify/theme-sections";
import templates from "./templates";

export default (sections) => {
  sections = sections.concat(templates);

  const imports = sections.filter((template) => {
    if (template.sections) {
      for (let section of template.sections) {
        if (document.querySelector('[data-section-type="' + section + '"]'))
          return true;
      }
    } else {
      return (
        template.templates.filter(
          (template) => window.Moonbase.template.indexOf(template) > -1
        ).length > 0
      );
    }
  });

  const promises = [];

  for (const i of imports) {
    const promise = new Promise((resolve) => {
      const script = document.createElement("script");
      const scripts = document.getElementsByTagName("script")[0];
      script.src = i.path || '{{ "' + i + '.js" | asset_url }}';
      script.onload = resolve;
      scripts.parentNode.insertBefore(script, scripts);
    });
    promises.push(promise);
  }

  return Promise.all(promises).then(() => load("*"));
};

// Fix to reload sections when viewed in customiser
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function (event) {
    // Reinit swipers
    const section = event.srcElement;
    if (section.querySelector(".swiper")) {
      const swipers = section.querySelectorAll(".swiper");
      swipers.forEach((swiper) => {
        const parameters = JSON.parse(swiper.dataset.swiper);
        new window.Moonbase.Swiper(swiper, parameters);
      });
    }
  });
  // Fix to reload sections when viewed in customiser
  document.addEventListener("shopify:inspector:activate", function (event) {
    // Reinit swipers
    const section = event.srcElement;
    if (section.querySelector(".swiper")) {
      const swipers = section.querySelectorAll(".swiper");
      swipers.forEach((swiper) => {
        const parameters = JSON.parse(swiper.dataset.swiper);
        new window.Moonbase.Swiper(swiper, parameters);
      });
    }
  });
}
